import { Grid, ToggleButton, ToggleButtonGroup, alpha, styled } from "@mui/material";

import { useFormContext } from "react-hook-form";
import { useSearchParams } from "react-router-dom";

function AmountType({ tradeInitial }) {
  const { setValue, watch } = useFormContext();
  const amountTypeId = watch("amountTypeId");

  const [searchParams, setSearchParams] = useSearchParams();

  const handleChange = (_, newValue) => {
    if (newValue) {
      const allSearchParams = Object.fromEntries([...searchParams]);
      setSearchParams({ ...allSearchParams, amountTypeId: newValue });

      setValue("amountTypeId", newValue);
    }
  };

  return (
    <Grid container mb={1}>
      <Grid item xs={12}>
        <ToggleButtonGroupStyle
          color="text"
          value={amountTypeId}
          exclusive
          onChange={handleChange}
          disableRipple={true}
          disableFocusRipple={true}
        >
          {tradeInitial?.lisAmountType?.map((amountType) => (
            <ToggleButtonStyle value={amountType?.id}>
              {amountType?.name}
            </ToggleButtonStyle>
          ))}
        </ToggleButtonGroupStyle>
      </Grid>
    </Grid>
  );
}

const ToggleButtonGroupStyle = styled(ToggleButtonGroup)(({ theme }) => ({
  width: "100%",
}));

const ToggleButtonStyle = styled(ToggleButton)(({ theme }) => ({
  width: "100%",
  borderRadius: "8px !important",
  border: "none",
  padding: theme.spacing(0.5),
  fontSize: "12px",
  color: theme.palette.text.main,
  backgroundColor: theme.palette.modules.input,
  marginLeft: theme.spacing(0.5),
  marginRight: theme.spacing(0.5),
  
  "&:first-child": {
    marginLeft: theme.spacing(0),
  },

  "&:last-child": {
    marginRight: theme.spacing(0),
  },

  "&.Mui-selected": {
    backgroundColor: `${theme.palette.background.tradeTypeButtonActive}`,
    color: theme.palette.background.tradeTypeButtonColor,
    
    "&:hover": {
      backgroundColor: `${theme.palette.background.tradeTypeButton} !important`,
    },
  },
  // "&:hover": {
  //   color: theme.palette.background.tradeTypeButtonColor,
  //   backgroundColor: `${theme.palette.background.tradeTypeButtonActive} !important`,
  // },
}));

export default AmountType;
